var _style, _rect, _g, _rect2, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st0",
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M765.6,655.8h33.7v-22.4C794.1,636.9,774.8,649.7,765.6,655.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270,636.1v22.4h33.7C294.5,652.5,275.2,639.6,270,636.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M803.6,232v-15.3c-3.8,2.2-228.4,127.9-232.2,130.1l-0.1,0V363L787,494.3c-7,4.7-16.3,10.9-27.2,18.2 l-1.4-0.8l0,0c-9.8-6-187.3-113.9-187.3-113.9V414c11.6,7,168.9,102.7,175.9,107c-8.5,5.7-17.6,11.8-27.1,18.1l-148.8-90.5v16.3 l132.8,80.8l0,0l3.2,1.9c-9,6-18.1,12.1-27.1,18.2l-108.9-66.3v16.3l96.1,58.5C618.6,607,574,636.8,569.3,640l0.5,13.6 c18.2-12.1,218.7-146.1,230.5-153.9l-0.5-13.9l0,0l-54-32.9c3.6-2,57.4-32.3,57.8-32.5v-15.2c-6.6,3.7-64.4,36.1-70.9,39.7 l-27.1-16.5c6.1-3.4,93.5-52.4,98-54.9v-15.3c-8.2,4.6-103,57.7-111.1,62.2l-27.3-16.6c6.1-3.4,132.9-74.5,138.4-77.5v-15.3 c-7.5,4.2-119.1,66.7-151.5,84.8l-27.3-16.6c6.9-3.9,172.3-96.5,178.7-100.1v-15.3c-39.2,22-185.1,103.7-191.8,107.5l-27.3-16.6 l214.7-120.3L803.6,232z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M640.9,655.8c28.3-18.8,120.5-79.9,158.5-105.2v-16c-54.3,36.2-129.4,85.8-182.5,121.2H640.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M715.3,655.8c5.2-3.4,78.2-51.9,84-55.8v-16c-34.6,23.1-73.6,48.8-108.1,71.8H715.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "437,488.5 428.3,493.8 428.3,510.1 437,504.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "464.5,488.1 498,467.7 498,451.4 464.5,471.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270,553.3c38,25.3,130.2,86.4,158.5,105.2h24.1c-53.1-35.4-128.2-85.1-182.5-121.2V553.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270,602.7c5.9,3.9,78.8,52.3,84,55.8h24.1c-34.6-23-73.6-48.8-108.1-71.8V602.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498,518.6v-16.3c-8.6,5.3-39.5,24-47.5,28.9c0-13.8,0-37.3,0-51l0,0l0-2.4c0,0,0-32.3,0-32.3l47.5-28.9 v-16.3l-147.3,89.6l0,0c-9.7,5.9-41.3,25.2-41.3,25.2c-10.8-7.2-20-13.4-27-18.1L498,365.8v-16.3l-0.1,0 c-4.5-2.5-227.8-127.6-232.2-130.1v15.3l4.5,2.5l214.7,120.3l-27.3,16.6c-6.2-3.5-153.1-85.7-191.8-107.5v15.3 c6.4,3.6,171.8,96.2,178.7,100.1l-27.3,16.6c-32.5-18.2-143.7-80.5-151.5-84.8v15.3c5.4,3,132.3,74.1,138.4,77.5l-27.3,16.6 c-8.1-4.5-102.9-57.6-111.1-62.2v15.3c4.5,2.5,91.9,51.5,98,54.9l-27.1,16.5c-6.5-3.6-64.3-36-70.9-39.7v15.2 c0.4,0.2,54.2,30.5,57.8,32.5l-54,32.9l0,0l-0.5,13.9c11.8,7.9,212.3,141.8,230.5,154l0.5-13.6c-4.7-3.2-49.3-33-98.1-65.7 C401.9,577.1,470.9,535.1,498,518.6z M412.2,468.9l28.9-17.6l0,32.3c0,13.2,0,39.9-0.1,53.4c-4,2.5-18.8,11.4-22.5,13.7l0,0 l-6.3,3.9L412.2,468.9z M362,550.4l26.7-16.2v-16.3l-39.5,24c-9.5-6.3-18.6-12.4-27.1-18.1l80.6-49.1c0,26.7-0.1,59.1-0.1,85.6 l-13.5,8.2C380.1,562.5,371,556.4,362,550.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.9,759.9l-13.4-19.2c-0.8,0.1-1.7,0.1-2.5,0.1h-14.8v19.1H301v-65.7h27c17.3,0,28,8.8,28,23.4 c0,9.9-5.1,17.3-14,20.7l15.1,21.6H343.9z M327.4,704.6h-14.3v26.2h14.3c10.7,0,16.2-4.9,16.2-13.1S338.1,704.6,327.4,704.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430,749.7v10.2h-49.2v-65.7h47.9v10.2H393v17.1h31.7v10H393v18.1H430z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.5,744.7h-32.8l-6.5,15.2h-12.6l29.5-65.7h12l29.6,65.7H504L497.5,744.7z M493.4,735.1l-12.4-28.7 l-12.3,28.7H493.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M536.4,694.2h12.2v55.3h34.3v10.3h-46.5V694.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.9,694.2H616v65.7h-12.2V694.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.4,704.6h-21.8v-10.3h55.7v10.3h-21.8v55.3h-12.2V704.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M740.1,736.7v23.2H728v-23l-25.8-42.7h13l19.2,32l19.4-32h12L740.1,736.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299,835.6l2.3-4.5c4,3.9,11.1,6.8,18.4,6.8c10.5,0,15-4.4,15-9.9c0-15.3-34.4-5.9-34.4-26.6 c0-8.2,6.4-15.3,20.6-15.3c6.3,0,12.8,1.8,17.3,4.9l-2,4.7c-4.8-3.1-10.4-4.6-15.3-4.6c-10.2,0-14.8,4.5-14.8,10.1 c0,15.3,34.4,6.1,34.4,26.4c0,8.2-6.5,15.2-20.8,15.2C311.4,842.9,303.2,840,299,835.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.8,814.5c0-16.4,12.4-28.4,29.3-28.4c8.1,0,15.5,2.7,20.4,8.1l-3.7,3.7c-4.5-4.6-10.1-6.6-16.5-6.6 c-13.5,0-23.6,9.9-23.6,23.1s10.1,23.1,23.6,23.1c6.4,0,12-2,16.5-6.7l3.7,3.7c-4.9,5.4-12.3,8.2-20.5,8.2 C412.2,842.9,399.8,830.9,399.8,814.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M547,827.5h-31.1l-6.7,14.9H503l25.5-55.8h5.8l25.5,55.8h-6.2L547,827.5z M544.8,822.7l-13.4-30l-13.4,30 H544.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M620.4,786.6h5.9v50.7h31.3v5.1h-37.2V786.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M758.2,837.3v5.1h-39.5v-55.8H757v5.1h-32.4v19.9h28.9v5h-28.9v20.7H758.2z"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 208.4,
    y: 168.4,
    className: "st2",
    width: 645.4,
    height: 741.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalSvg);
export default __webpack_public_path__ + "static/media/Final_SVG.0ef6a74c1db25e26e5118ce8f3aae5c4.svg";
export { ForwardRef as ReactComponent };